import React from 'react';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import PageEnvelope from '../elements/PageEnvelope';
import { Navigate } from 'react-router-dom';
import { getDeviceType, getOperatingSystem, isAppleDevice } from '../util/util';
import { getNotificationsPermission } from '../util/notifications';
import './SitePage.css';

interface SettingsPageState {
  message: string;
  alert: string;
  install: number;
  notifications: number;
  directOn: boolean;
  likesOn: boolean;
  repliesOn: boolean;
  activityOn: boolean;
  blogsOn: boolean;
  forumsOn: boolean;
  directOff: boolean;
  likesOff: boolean;
  repliesOff: boolean;
  activityOff: boolean;
  blogsOff: boolean;
  forumsOff: boolean;
}

class SettingsPage extends React.Component<{}, SettingsPageState> {
  public static pwa = null;
  protected badgeCount:number = 0;
  protected badgeInterval:any;

  constructor(props:{}) {
    super(props);

    this.state = {
      message: '',
      alert: '',
      install: -1,
      notifications: -1,
      directOn: false,
      likesOn: false,
      repliesOn: false,
      activityOn: false,
      blogsOn: false,
      forumsOn: false,
      directOff: false,
      likesOff: false,
      repliesOff: false,
      activityOff: false,
      blogsOff: false,
      forumsOff: false,
    };
  }

  componentDidMount(): void {
    if(SettingsPage.pwa)
      this.setState({install: 0});
    else if(this.isInstalledOnDevice())
      this.setState({install: 1});
    else
      this.setState({install: -1});

    let device = getDeviceType();
    let permisson = getNotificationsPermission();
    let notifications = -1;
    if(device == 'desktop' && permisson) {
      let granted = (permisson == 'granted');
      let storage = window.localStorage.getItem('DeviceNotifications') == '1';
      notifications = granted && storage ? 1 : 0;
    }

    this.setState({notifications});

    if(notifications == 1)
      this.updateNotificationsFromStorage();

    console.log(getOperatingSystem())
  }

  onEnableDeviceNotifications() {
    let perm = getNotificationsPermission();
    if(!perm) return;

    if(perm == 'denied') {
      this.setState({alert: 'Notifications are currently blocked by the web browser.  You can unblock them in the browser settings for this website.'});
    }
    else if(perm == 'granted') {
      this.enableNotifications();
    }
    else {
      Notification.requestPermission().then((res)=>{
        this.enableNotifications();
      });
    }
  }

  getStorageItemState(item:string):boolean {
    return window.localStorage.getItem(item) == '1';
  }

  enableNotifications() {
    let storage = window.localStorage;
    storage.setItem('DeviceNotifications', '1');
    this.updateNotificationsFromStorage();
  }

  updateNotificationsFromStorage() {
    let storage = window.localStorage;
    let direct = storage.getItem('DeviceNotificationsDirect') ? storage.getItem('DeviceNotificationsDirect') == '1' : true;
    let likes = storage.getItem('DeviceNotificationsLikes') ? storage.getItem('DeviceNotificationsLikes') == '1' : true;
    let replies = storage.getItem('DeviceNotificationsReplies') ? storage.getItem('DeviceNotificationsReplies') == '1' : true;
    let activity = storage.getItem('DeviceNotificationsActivity') ? storage.getItem('DeviceNotificationsActivity') == '1' : true;
    let blogs = storage.getItem('DeviceNotificationsBlogs') ? storage.getItem('DeviceNotificationsBlogs') == '1' : true;
    let forums = storage.getItem('DeviceNotificationsForums') ? storage.getItem('DeviceNotificationsForums') == '1' : true;

    this.setState({
      notifications: 1,
      directOn: direct,
      likesOn: likes,
      repliesOn: replies,
      activityOn: activity,
      blogsOn: blogs,
      forumsOn: forums,
      directOff: !direct,
      likesOff: !likes,
      repliesOff: !replies,
      activityOff: !activity,
      blogsOff: !blogs,
      forumsOff: !forums
    });

    storage.setItem('DeviceNotificationsDirect', direct ? '1' : '0');
    storage.setItem('DeviceNotificationsLikes', likes ? '1' : '0');
    storage.setItem('DeviceNotificationsReplies', replies ? '1' : '0');
    storage.setItem('DeviceNotificationsActivity', activity ? '1' : '0');
    storage.setItem('DeviceNotificationsBlogs', blogs ? '1' : '0');
    storage.setItem('DeviceNotificationsForums', forums ? '1' : '0');
  }

  onDisableDeviceNotifications() {
    window.localStorage.setItem('DeviceNotifications', '0');
    this.setState({
      notifications: 0,
      directOn: false,
      likesOn: false,
      repliesOn: false,
      activityOn: false,
      blogsOn: false,
      forumsOn: false,
      directOff: false,
      likesOff: false,
      repliesOff: false,
      activityOff: false,
      blogsOff: false,
      forumsOff: false
    })
  }

  isInstalledOnDevice() {
    // if ('getInstalledRelatedApps' in navigator) {
    //   (navigator as any).getInstalledRelatedApps().then(apps => {
    //     console.log(apps);
    //     if (apps.length > 0) {
    //       console.log('PWA is installed');
    //     } else {
    //       console.log('PWA is not installed');
    //     }
    //   });
    // }    

    if (window.matchMedia('(display-mode: standalone)').matches) 
      return true;
  
    return false;
  }

  onInstall() {
    SettingsPage.pwa.prompt();
    SettingsPage.pwa.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') 
        this.setState({install: 1});
    });
  }

  onUninstall() {
    this.setState({alert: 'You can uninstall the app just like any other app on your device.'})
  }

  renderNotificationRow(title:string, onState:string, offState:string, storage:string) {
    let disabled = this.state.notifications != 1;

    let onStateOn = {};
    onStateOn[onState] = true;
    onStateOn[offState] = false;

    let offStateOn = {};
    offStateOn[offState] = true;
    offStateOn[onState] = false;

    return (
      <div className="site-page-row" style={{justifyContent: 'space-between'}}>
        <div>{title}</div>
        <div style={{paddingRight: '10px'}}>
          <input 
            className="site-toggle-button-on" 
            type="checkbox" 
            disabled={disabled} 
            checked={this.state[onState]}
            value={this.state[onState]}
            onChange={(e:any)=>{
              this.setState(onStateOn);
              window.localStorage.setItem(storage, '1')
            }}
          />
          &nbsp;
          <input 
            className="site-toggle-button-off" 
            type="checkbox" 
            disabled={disabled}
            checked={this.state[offState]}
            value={this.state[offState]}
            onChange={(e:any)=>{
              this.setState(offStateOn)
              window.localStorage.setItem(storage, '0')
            }}
          />
        </div>
      </div>
    )
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    let device = getDeviceType();
    let os = getOperatingSystem();
    let isApple = isAppleDevice();
    
    let deviceNotificationButton = null;
    switch(this.state.notifications) {
      case -1:
        deviceNotificationButton = <button disabled={true}>Coming Soon</button>;
        break;
      case 0:
        deviceNotificationButton = <button onClick={()=>this.onEnableDeviceNotifications()}>Enable</button>;
        break;
      case 1:
        deviceNotificationButton = <button onClick={()=>this.onDisableDeviceNotifications()}>Disable</button>;
        break;
    }

    let installButton = null;
    switch(this.state.install) {
      case -1:
        installButton = <button disabled={true}>{this.isInstalledOnDevice() ? 'Already Installed' : 'Not Supported'}</button>;
        break;
      case 0:
        installButton = <button onClick={()=>this.onInstall()}>Install</button>;
        break;
      case 1:
        installButton = <button onClick={()=>this.onUninstall()}>Uninstall</button>;
        break;
    }

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">

            <div className="site-page-panel">
              <div className="site-page-column">
                <div className="site-page-row" style={{justifyContent: 'space-between'}}>
                  <div><b>{device == 'desktop' ? 'Desktop' : 'Mobile'} Notifications</b></div>
                  <div>{deviceNotificationButton}</div>
                </div>
                {this.renderNotificationRow('Direct Messages', 'directOn', 'directOff', 'DeviceNotificationsDirect')}
                {this.renderNotificationRow('Activity Likes', 'likesOn', 'likesOff', 'DeviceNotificationsLikes')}
                {this.renderNotificationRow('Activity Replies', 'repliesOn', 'repliesOff', 'DeviceNotificationsReplies')}
                {this.renderNotificationRow('New Activity', 'activityOn', 'activityOff', 'DeviceNotificationsActivity')}
                {this.renderNotificationRow('New Blogs', 'blogsOn', 'blogsOff', 'DeviceNotificationsBlogs')}
                {this.renderNotificationRow('New Forum Posts', 'forumsOn', 'forumsOff', 'DeviceNotificationsForums')}
              </div>
            </div>

            <div className="site-page-panel">
              <div className="site-page-column">
                <div className="site-page-row" style={{justifyContent: 'space-between'}}>
                  <div><b>{device == 'desktop' ? 'Desktop App' : 'Home Screen App'}</b></div>
                </div>

                {device == 'desktop' &&
                  <div>
                    Install this website as an app on your desktop where it will have it's own icon like any other app, run fullscreen without browser bars, and show notification counts.
                  </div>
                }

                {device != 'desktop' &&
                  <div>
                    You can add this website to your Home Screen where it will have it's own icon like any other app, run fullscreen without browser bars, and show notification counts.
                  </div>
                }

                {!isApple &&
                  <div>
                    {installButton}
                  </div>
                }

                {isApple &&
                  <div className="site-page-column">
                    <div>
                      Press the Share button on the top or bottom bar of the web browser:
                    </div>  
                    <div style={{textAlign: 'center'}}>
                      <img style={{borderRadius: '10px'}} src="/settings/share-button.png"/>
                    </div>  
                    <div>
                      Then select Add to Home Screen and follow the prompts:
                    </div>  
                    <div style={{textAlign: 'center'}}>
                      <img style={{borderRadius: '10px'}} src="/settings/add-to-home.png"/>
                    </div>  
                    <div>
                      <i>This feature is only available in the Safari web browser on iOS.</i>
                    </div>
                  </div>
                }

              </div>
            </div>

          </div>
        </PageEnvelope>

        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default SettingsPage;
